import React from "react";
import { FiThumbsUp, FiMessageCircle, FiShare2 } from "react-icons/fi";
import "./SongActions.css";

const SongActions = ({
  liked = false,
  likeCount = 0,
  commentCount = 0,
  shareCount = 0,
  onLike,
  onCommentClick,
  onShare,
  loadingLike = false,
}) => {
  return (
    <div className="song-actions">

      {/* ================= LIKE ================= */}
      <button
        onClick={onLike}
        disabled={loadingLike}
        className={`song-action-btn ${liked ? "liked" : ""}`}
      >
        <FiThumbsUp />
        <span>{likeCount}</span>
      </button>

      {/* ================= COMMENT ================= */}
      <button
        onClick={onCommentClick}
        className="song-action-btn"
      >
        <FiMessageCircle />
        <span>{commentCount}</span>
      </button>

      {/* ================= SHARE ================= */}
      <button
        onClick={onShare}
        className="song-action-btn"
      >
        <FiShare2 />
        <span>{shareCount}</span>
      </button>

    </div>
  );
};

export default SongActions;